import { useEffect } from "react";

// Sets document.title and the meta description tag for the current page.
// CRA has no built-in per-route head management, and pulling in
// react-helmet for two static routes would be overkill.
export function useDocumentMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const metaEl = document.querySelector('meta[name="description"]');
    const prevDescription = metaEl?.getAttribute("content");
    if (metaEl && description) {
      metaEl.setAttribute("content", description);
    }

    return () => {
      document.title = prevTitle;
      if (metaEl && prevDescription != null) {
        metaEl.setAttribute("content", prevDescription);
      }
    };
  }, [title, description]);
}
